import { ReactElement } from 'react';
import { issuePickerItemHandler } from '../../../issues/issue-picker-helper';
import { ParentRecordState } from '../../../record-editor';
import { LinkedRecord } from '../../../shared/material_components/linked-cell';
import { taskPickerItemHandler } from '../../../tasks/fields/task-picker-helper';
import { recordPickerItemHandler } from '../record-link/record-picker-helper';
import { appLinkPickerItemHandler } from '../../../tasks/fields/app-link-picker-helper';
import {RestApiForm} from "../../../tasks/types";

export interface PickerItemHandler {
  view: (record: Record<string, any>, restForm: RestApiForm) => ReactElement;
  selectionHandler: (
    records: Record<string, any>[],
    selectedTaskIDs: any[],
    parentRecordState: ParentRecordState
  ) => {
    selectedTaskIDs: any[];
    newParentRecordState: {
      allowMultiple: boolean;
      currentParentRecord: LinkedRecord | undefined;
      newParentRecord: LinkedRecord | undefined;
    };
  };
  recordLinkedTitle: string;
  selectorTitle: string;
  allowMultiple: boolean;
}

export const getLinkagePickerItem = (dataName: string): PickerItemHandler => {
  switch (dataName) {
    case 'linked_tasks':
      return taskPickerItemHandler();
    case 'issues':
      return issuePickerItemHandler();
    case 'applink':
      return appLinkPickerItemHandler();
    default:
      return recordPickerItemHandler();
  }
};

export enum StatusColorMap {
  complete = '#87D30F',
  'in progress'= '#FFCC00',
  open = '#4BAEF8',
  'needs resolution'= '#FFD300',
  resolved = '#87D30F',
}
